import listCourse from "./listCourse/sagas"
import listBanner from "./listBanner/sagas"
export default [
  listCourse(),
  listBanner()
]
